export enum NotificationType {
  Permanent,
  Temporary,
}
